import Vue from "vue";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */

export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    apiGetBlobByAppNameAndPath: function (appName, path) {
        // var currentTime = new Date().getTime() / 1000;
        // ?time=${currentTime}
        var url = `${this.config().bzbsBlobUrl}/config/${appName}/${path}`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    }
}